// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"8c4afe9d","72":"a9b781cd","166":"296794af","330":"ac50aa98","401":"2bc5a8bf","470":"0f689f18","520":"e778644b","558":"1987fe45","627":"e0c39ced","677":"d9abcf90"}[chunkId] + ".chunk.js";
};